// import { Turbo } from "@hotwired/turbo-rails"
import "@hotwired/turbo"

// if (Turbo.supported) {
  Turbo.setProgressBarDelay(0);
// }
